import { TimeFormatType } from './time-format-key'

export const TIME_FORMAT_OPTIONS = [
  { value: TimeFormatType.H24, label: '24 hour' },
  { value: TimeFormatType.H12, label: '12 hour' },
]
